import * as React from "react";
import { useTl, useApiService } from "../../../../hooks";
import { useHistory } from "react-router";
import { useGlobalData } from "../../../../contexts";
import { IDataTableColumn, ButtonContainer } from "nsitools-react";
import { ViewButton, EditButton, SearchTablePage, EmailButton } from "../../../../components";
import { ERoutes } from "../../../../ERoutes";
import { ETLCodes } from "../../../../locales";
import { Checkbox } from "@blueprintjs/core";
import { UserGridDto, UsersApi, UserSearch } from "../../../../api";

export interface IUserListPageProps {}

export const UserListPage: React.FunctionComponent<IUserListPageProps> = (props) => {
  const { t } = useTl();
  const api = useApiService(UsersApi);
  const history = useHistory();
  const { currentLanguage } = useGlobalData();

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        computed: true,
        disableSorting: true,
        fieldName: "actions",
        autoFitContent: true,
        render: (row: UserGridDto) => (
          <ButtonContainer>
            <ViewButton minimal={true} onClick={() => history.push(`${ERoutes.user}/${row.userId}/detail/view`)} />
            <EditButton minimal={true} onClick={() => history.push(`${ERoutes.user}/${row.userId}/detail/edit`)} />
          </ButtonContainer>
        ),
      },
      {
        fieldName: "lastName",
        header: () => t(ETLCodes.LastName),
      },
      {
        fieldName: "firstName",
        header: () => t(ETLCodes.FirstName),
      },
      {
        fieldName: "email",
        header: () => t(ETLCodes.Email),
        render: (row: UserGridDto) => <EmailButton email={row.email} />,
      },
      {
        fieldName: "language",
        header: () => t(ETLCodes.Language),
      },
      {
        fieldName: "userProfile",
        header: () => t(ETLCodes.Profile),
      },
      {
        fieldName: "active",
        autoFitContent: true,
        header: () => t(ETLCodes.Active),
        render: (row: UserGridDto) => <Checkbox disabled checked={row.active} />,
      },
    ],
    [history, t]
  );

  const addItemFunction = React.useCallback(() => {
    history.push(`${ERoutes.user}/0/detail/edit`);
  }, [history]);

  const exportFunction = React.useCallback(
    (sObj) => api.exportXlsFile(UserSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId })),
    [api, currentLanguage.languageId]
  );
  const search = React.useCallback((sObj) => api.baseSearch(UserSearch.fromJS(sObj)), [api]);
  return (
    <SearchTablePage
      columns={columns}
      getCriteriasFunction={() => api.getSearchCriterias(true)}
      searchFunction={search}
      addFunc={addItemFunction}
      exportFunction={exportFunction}
      sortKeys={{ lastName: "ASC" }}
      breadCrumbs={[{ text: t(ETLCodes.Users) }]}
    />
  );
};
